import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import { useLanguage, pickLang } from "../../contexts/LanguageContext";
import { getMenus } from "../../services/api";
import "./Header.css";

const Header = () => {
  const { orgName, logoUrl, loading } = useTheme();
  const { language, toggleLanguage } = useLanguage();
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    getMenus()
      .then((res) => {
        if (res.data.success) setMenuItems(res.data.data);
      })
      .catch(() => {
        // Fallback: header tetap tampil meski gagal load menu
      });
  }, []);

  // Bangun struktur tree
  const topLevel = menuItems.filter((m) => !m.parent_id);
  const childrenOf = (parentId) =>
    menuItems.filter((m) => m.parent_id === parentId);

  // Tentukan path/href sebuah item
  const menuLink = (item) => {
    if (item.menu_type === "content") {
      return `/halaman/${item.content_jenis}`;
    }
    return item.url || "#";
  };

  const isExternal = (url) =>
    url && (url.startsWith("http://") || url.startsWith("https://"));

  const renderNavItem = (item) => {
    const children = childrenOf(item.id);
    const href = menuLink(item);
    const external = isExternal(href);
    const target = item.target || "_self";
    const label = pickLang(item, "label", language);

    if (children.length > 0) {
      return (
        <NavDropdown
          key={item.id}
          title={label}
          id={`menu-dropdown-${item.id}`}
          renderMenuOnMount={true}
        >
          {children.map((child) => {
            const childHref = menuLink(child);
            const childExternal = isExternal(childHref);
            const childLabel = pickLang(child, "label", language);
            if (childExternal) {
              return (
                <NavDropdown.Item
                  key={child.id}
                  href={childHref}
                  target={child.target || "_self"}
                  rel={
                    child.target === "_blank"
                      ? "noopener noreferrer"
                      : undefined
                  }
                >
                  {childLabel}
                </NavDropdown.Item>
              );
            }
            return (
              <NavDropdown.Item key={child.id} as={Link} to={childHref}>
                {childLabel}
              </NavDropdown.Item>
            );
          })}
        </NavDropdown>
      );
    }

    if (external) {
      return (
        <Nav.Link
          key={item.id}
          href={href}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
        >
          {label}
        </Nav.Link>
      );
    }

    return (
      <Nav.Link key={item.id} as={Link} to={href}>
        {label}
      </Nav.Link>
    );
  };

  return (
    <header>
      <Navbar bg="primary" variant="dark" expand="lg" sticky="top">
        <Container fluid="xl">
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={orgName || "Logo Lembaga"}
                height="40"
                className="me-2"
              />
            ) : loading ? (
              <span
                className="brand-logo-placeholder me-2"
                aria-hidden="true"
              />
            ) : null}
            {orgName || (loading ? <span className="brand-name-placeholder" aria-hidden="true" /> : null)}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              {topLevel.map((item) => renderNavItem(item))}
              <button
                className="lang-flag-btn"
                onClick={toggleLanguage}
                title={language === "id" ? "Switch to English" : "Ganti ke Indonesia"}
              >
                <span
                  className={`fi ${language === "id" ? "fi-gb" : "fi-id"}`}
                />
              </button>
              <Nav.Link
                as={Link}
                to="/admin/login"
                className="btn ms-lg-2 px-3 header-login-btn"
              >
                <i className="fas fa-sign-in-alt me-1"></i>
                Login
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
